import { type CurrencyType } from 'src/types/currency';
import { type getTranslationFn } from 'src/utils/get-translation-fn';

export const getLearnMoreBackgroundTitle = (
  currency: CurrencyType,
  t: ReturnType<typeof getTranslationFn>
) => {
  if (currency === 'SAR') {
    return t('pay_over_time');
  }

  return t('paid_plans.get_more_time_to_pay');
};
